import React from "react";
import { Formik } from "formik";
import { TextField, withStyles, Button, Typography, CircularProgress, InputLabel, Select,MenuItem } from "@material-ui/core";
import * as Yup from "yup";
import {queryTypes} from '../../sc-utilities';

const styles = theme => ({
    root: {
        flexGrow: 1,
        paddingTop: theme.spacing(2)
    },
    submit: {
        textTransform: 'none',
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
        width: "100%",
        marginTop: "10px"
    }
});

const TableViewForm = props => {
    const { classes, formSettings, initialValues, handleSubmit, translations } = props;

    return (
        <div className={classes.root}>
            <Formik
                initialValues={initialValues}
                onSubmit={async (values, { setSubmitting }) => {
                    setSubmitting(true);
                    await handleSubmit(values);
                    setSubmitting(false);

                }}
                validationSchema={Yup.object().shape(formSettings.Validation)}
            >
                {formikProps => {
                    const { values, touched, errors, isValid, dirty, isSubmitting, handleChange, handleBlur, handleSubmit } = formikProps;
                    return (
                        <form onSubmit={handleSubmit}>
                            <Typography variant={"h6"}>{formSettings.FormTitle ? formSettings.FormTitle : null}</Typography>
                            <TextField
                                name="Name"
                                value={values.Name}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.Name && touched.Name)}
                                placeholder={translations["name"] || "Name"}
                                label={translations["name"] || "Name"}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <InputLabel shrink>{translations["table_view_type_select"] || "Please select view type"}</InputLabel>
                            <Select
                                name="QueryType"
                                label={translations["table_view_type"] || 'Table View type'}
                                margin={"dense"}
                                value={values.QueryType || ''}
                                fullWidth={true}
                                onChange={handleChange}
                            >
                                {(queryTypes ? queryTypes : []).map(option => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {translations[option.label] || option.Name}
                                    </MenuItem>
                                ))}
                            </Select>
                            <TextField
                                name="Parameters"
                                value={values.Parameters}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.Parameters && touched.Parameters)}
                                placeholder={translations["parameters"] || "Parameters"}
                                label={translations["parameters"] || "Parameters"}
                                margin={"dense"}
                                fullWidth={true}
                            />

                            <div>
                                {formSettings.ButtonSubmit ? (
                                    <Button
                                        className={classes.submit}
                                        variant="contained"
                                        type="submit"
                                        disabled={isSubmitting || !(isValid && dirty)}
                                    >
                                        {(isSubmitting) ? <CircularProgress size={24} /> : formSettings.ButtonSubmit.Title}
                                    </Button>
                                ) : null}
                            </div>
                        </form>
                    );
                }}
            </Formik>
        </div >
    );
};

export default withStyles(styles, { withTheme: true })(TableViewForm);
